// src/contexts/token/useTokenPrice.ts
/**
 * Hooks for TokenPriceContext
 * Separated for Fast Refresh compatibility
 */

import { useContext } from "react";
import { TokenPriceContext } from "./TokenPriceProvider";
import type { TokenPriceContextValue } from "./types";

export function useTokenPrice(): TokenPriceContextValue {
  const context = useContext(TokenPriceContext);
  if (!context) {
    throw new Error("useTokenPrice must be used within a TokenPriceProvider");
  }
  return context;
}

export function useTokenPriceOptional(): TokenPriceContextValue | null {
  return useContext(TokenPriceContext);
}

